export const reducerTypes = {
  GET_ALL_INSTA_MEDIA: "reducer/GET_ALL_INSTA_MEDIA",
};

export const sagaTypes = {
  GET_ALL_INSTA_MEDIA: "saga/GET_ALL_INSTA_MEDIA",
};
